
import { BasicModel } from "@goodgamestudios/core";
import { TimeStringHelper } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2TourInvitationDialogProperties } from "./Poker2TourInvitationDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2TourInvitationDialog extends Poker2Dialog {
    public static NAME: string = "Poker2TourInvitationDialog";

    constructor(disp: Container) {
        super(disp);
    }
    protected init(): void {
        super.init();
    }
    protected applyProperties(): void {
        this.invitationDialog.txt_title.text = this.invitationDialogProperties.name;
        var time: string = TimeStringHelper.getTimeToString(Math.abs(this.invitationDialogProperties.runtime), TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
        // "Aktuelle Runde läuft seit ..."
        if (this.invitationDialogProperties.runtime < 0)
            this.invitationDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_tournament_invitation_copy_2", [time]);
        else {
            // "Dein Turnier beginnt in ..." oder ab der zweiten Runde: "Runde XXX beginnt in ..."
            if (this.invitationDialogProperties.round == 1)
                this.invitationDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_tournament_invitation_copy", [time]);
            else
                this.invitationDialog.txt_copy.text = Poker2Model.languageData.getTextById("dialog_tournament_invitation_copy_3", [this.invitationDialogProperties.round, time]);
        }
        this.invitationDialog.btn_ok.label = Poker2Model.languageData.getTextById("lobby_tour_play");
        this.invitationDialog.btn_cancle.label = Poker2Model.languageData.getTextById("generic_btn_no");

        if (this.tutorialController.isActive) {
            this.tutorialController.cancelTutorial();
        }
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.invitationDialog.btn_cancle:
                this.hide();
                break;
            case this.invitationDialog.btn_ok:
                this.playTournament(this.invitationDialogProperties.tournamentId);
                this.hide();
                break;
        }
    }
    private playTournament(tournamentId: number): void {
        var paramObject: any = { id: tournamentId };
        BasicModel.smartfoxClient.sendMessage("jjn", [JSON.stringify(paramObject)]);
    }

    protected get invitationDialogProperties(): Poker2TourInvitationDialogProperties {
        return this.properties as Poker2TourInvitationDialogProperties;
    }
    protected get invitationDialog(): Library.PokerInterface.PokerTournmentInvitation {
        return this.disp as Library.PokerInterface.PokerTournmentInvitation;
    }
}
